export const iconFontAwesomeDisasterCrisisBugs = (
	<i className="fa-solid fa-bugs"></i>
);
